angular.module('elfium').filter('elfiumMissingRequiredFields', function () {
    return function (object, requiredFields) {
    	var missingRequiredFields = [];
    	angular.forEach(requiredFields, function (requiredFieldLabel, requiredField) {
    		if (!object[requiredField]) {
    			missingRequiredFields.push(requiredFieldLabel);
    		}
    	});
        return missingRequiredFields;
    };
});


// WEBPACK FOOTER //
// ./src/app/components/elfium/elfiumMissingRequiredFieldsFilter.ts